
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { CourseModel } from '@descomplica/dex-models';
import { Assessment, ASSESSMENT_STATUS, ASSESSMENT_TYPE } from '@/models/assessment.model';
import PostGradAssessmentsCardRow from './PostGradAssessmentsCardRow.vue';
import PostGradAssessmentsModalWrapper from '../../modals/assessments/PostGradAssessmentsModalWrapper.vue';

interface Data {
  showModal: boolean;
  selectedAssessment: Assessment | undefined;
  isFirstAssessment: boolean;
}

export default Vue.extend({
  components: {
    Icon,
    PostGradAssessmentsCardRow,
    PostGradAssessmentsModalWrapper,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data(): Data {
    return {
      showModal: false,
      selectedAssessment: undefined,
      isFirstAssessment: false,
    };
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    assessments(): Assessment[] {
      return this.$store.getters.assessments;
    },
    isDescomplicaStandard(): boolean {
      return this.matchesAssessmentTypes([
        ASSESSMENT_TYPE.DEX,
        ASSESSMENT_TYPE.CASE_STUDY,
        ASSESSMENT_TYPE.PRESENTATION,
      ]);
    },
    showPostgradTCCAssessment(): boolean {
      return this.$store.getters.showPostgradTCCAssessment;
    },
    isCourseWithTCC(): boolean {
      return (
        this.matchesAssessmentTypes([ASSESSMENT_TYPE.DEX, ASSESSMENT_TYPE.TCC]) ||
        this.matchesAssessmentTypes([ASSESSMENT_TYPE.TCC])
      );
    },
  },
  async created() {
    this.$store.dispatch('PULL_MINIMUM_ASSESSMENT_DATA', { dexCourseId: this.currentCourse.id });
  },
  methods: {
    handleRowClick(assessment: Assessment) {
      const {
        assessmentType: type,
        assessmentStatusByUser: status,
        currentRelatedCourse: { isAvailable },
      } = assessment;

      if (!isAvailable) return;
      if (type !== ASSESSMENT_TYPE.DEX && status === ASSESSMENT_STATUS.WAITING_GRADING) return;

      if (type === ASSESSMENT_TYPE.DEX && status === ASSESSMENT_STATUS.PASSED) {
        this.redirectToDex(assessment);
      } else {
        this.openModal(assessment);
      }
    },
    async redirectToDex(assessment: Assessment) {
      const data = { dexCourseId: this.currentCourse.id, assessmentId: assessment.id };

      await this.$store.dispatch('PULL_ASSESSMENT_MODULE_ONE_VARIANT_LINK', data);
      window.location.replace(this.$store.getters.assessmentDetails.currentVariantByUser.link);
    },
    matchesAssessmentTypes(typesToMatch: ASSESSMENT_TYPE[]): boolean {
      const assessmentTypes = this.assessments.map((assessment) => assessment.assessmentType);
      const hasAllTypes = typesToMatch.every((type) => assessmentTypes.includes(type));

      return hasAllTypes && this.assessments.length === typesToMatch.length;
    },
    openModal(assessment: Assessment) {
      this.selectedAssessment = assessment;
      this.isFirstAssessment = !this.assessments.some(
        ({ minimumContractDays }) => assessment.minimumContractDays > minimumContractDays,
      );

      this.showModal = true;
    },
    updateShowModal(active: boolean) {
      this.showModal = active;
    },
  },
});
